import React from 'react';
import { BoatState, PointOfSail } from '../types';
import { useTheme } from '../../../context/ThemeContext';

interface HUDProps {
  boat: BoatState;
}

const pointOfSailLabels: Record<PointOfSail, string> = {
  inIrons: 'In Irons',
  closeHauled: 'Close Hauled',
  closeReach: 'Close Reach',
  beamReach: 'Beam Reach',
  broadReach: 'Broad Reach',
  running: 'Running',
};

export const HUD: React.FC<HUDProps> = ({ boat }) => {
  const { isDarkMode } = useTheme();

  const headingDegrees = Math.round(
    ((boat.heading * 180) / Math.PI + 360) % 360
  );

  const getCompassDirection = (degrees: number): string => {
    const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
    const index = Math.round(degrees / 45) % 8;
    return directions[index];
  };

  return (
    <div
      className={`absolute top-4 left-4 p-4 rounded-lg font-mono text-sm space-y-2 shadow-lg backdrop-blur-sm border ${
        isDarkMode
          ? 'bg-gray-900/95 text-gray-100 border-gray-700'
          : 'bg-white/95 text-gray-800 border-gray-200'
      }`}
    >
      <div className="flex items-center gap-2">
        <span className="text-gray-500">SPD</span>
        <span className="text-lg font-bold">{boat.speed.toFixed(1)}</span>
        <span className="text-xs">kts</span>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-gray-500">HDG</span>
        <span className="text-lg font-bold">{headingDegrees}°</span>
        <span className="text-xs">{getCompassDirection(headingDegrees)}</span>
      </div>

      <div className="border-t border-gray-300 dark:border-gray-600 pt-2 mt-2">
        <div
          className={`font-semibold ${
            boat.pointOfSail === 'inIrons' ? 'text-red-500' : ''
          }`}
        >
          {pointOfSailLabels[boat.pointOfSail]}
        </div>
        {boat.pointOfSail === 'inIrons' && (
          <div className="text-red-500 text-xs animate-pulse">
            STALLED - Bear away!
          </div>
        )}
      </div>

      <div className="border-t border-gray-300 dark:border-gray-600 pt-2 mt-2 text-xs text-gray-500">
        <div>Heel: {Math.round((boat.heelAngle * 180) / Math.PI)}°</div>
        <div>Rudder: {Math.round((boat.rudderAngle * 180) / Math.PI)}°</div>
      </div>
    </div>
  );
};
